export default class Gtm {
    /**
     * Sends event data to GTM (Google Analytics)
     *
     * @param {string} eventType
     * @param {Object} params
     */
    sendEvent(eventType, params, ver = 1)
    {
        let data = null;

        switch (eventType) {
            case 'base':
                data = this.setBaseTrackingEvent(params, ver);
                break;
            case 'auth':
                data = this.setAuthEvent(params);
                break;
            case 'conversion':
                data = this.setConversionEvent(params, ver)
                break;
        }

        if (data !== null && window.dataLayer !== undefined && typeof dataLayer.push === 'function') {
            dataLayer.push(data);
            // console.log(data);
        }
    }

    /**
     * @param {Object} params
     */
    setBaseTrackingEvent(params, ver) {

        if (ver === 2) {
            return {
                orderId: params.orderID,
                event: params.event,
                ...params.products
            }
        }

        return {
            orderId: params.orderID,
            event: params.event,
            ecommerce: {
                checkout: {
                    actionField: {
                        ...params.actionField
                    },
                    products: [{
                        name: 'eLoan',
                        ...params.products
                    }],
                    pageTitle: params.pageTitle
                }
            },
            'gtm.uniqueEventId': params.eventId
        }
    }

    /**
     * @param {Object} params
     */
    setAuthEvent(params) {
        return {
            authenticationMethod: params.auth_method,
            authenticationAnswer: params.status,
            authenticationPurpose: params.auth_purpose,
            event: 'authenticationInteraction',
            'gtm.uniqueEventId': 1287
        }
    }

    /**
     * @param {Object} params
     */
    setConversionEvent(params, ver)
    {
        let productName;

        switch (params.productType) {
            case 'IL':
                productName = 'Consumer loan';
                break;
            case 'IA':
                productName = 'Car loan';
                break;
            case 'IR':
                productName = 'Renovation loan';
                break;
            case 'IS':
                productName = 'Green energy loan';
                break;
            case 'IC':
                productName = 'HP (sun collector)';
                break;
            default:
                productName = 'N/A';
        }

        if (ver === 2) {
            return {
                orderId: params.orderID,
                event: 'purchase',
                ...params.products
            }
        }

        return {
            orderId: params.orderID,
            event: 'purchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: params.orderID,
                        revenue: params.amount,
                    },
                    products: [{
                        name: productName,
                        id: params.orderID,
                        price: params.amount,
                        category: params.productType,
                        quantity: 1
                    }]
                }
            }
        }
    }
}
